export { fontLists } from "../common.js";
export const addressforwebteleprompter = window.location.origin.includes('https://vimlesh1975.github.io') ? 'https://octopus-app-gzws3.ondigitalocean.app' : 'https://localhost:9000';

export const fixdata = {
    "ScriptID": "202502071223160",
    "id": 636,
    "bulletinname": "simnews1",
    "bulletinlock": 0,
    "bulletindate": "2025-02-06T18:30:00.000Z",
    "bulletintype": "",
    "rowid": "202502071223160",
    "slno": 1,
    "SlugName": "No Slug Name",
    "Script": "No Script",
    "scriptmodifiedtime": "2025-02-07T06:55:51.000Z",
    "createdtime": "2025-02-07T06:53:16.000Z",
    "createdby": "binoy",
    "currentuser": "rajeev",
    "LastModifiedTime": "2025-02-07T11:46:46.000Z",
    "lastmodifiedby": null,
    "Lockscript": 0,
    "lockedby": null,
    "WordsCount": 1.31,
    "EditCode": "0",
    "autosavestatus": 0,
    "OneLinerText": null,
    "onelinermodifiedtime": null,
    "importedscriptid": null,
    "importedbulletinname": null,
    "media1": null,
    "media2": null,
    "media3": null,
    "media4": null,
    "media5": null,
    "media1duration": "00:00:00",
    "media2duration": "00:00:00",
    "media3duration": "00:00:00",
    "media4duration": "00:00:00",
    "media5duration": "00:00:00",
    "mediamodifiedtime": null,
    "mediamodifiedby": null,
    "source": null,
    "dropstory": 0,
    "archivestatus": 0,
    "graphicsid": null,
    "reporter1": null,
    "reporter2": null,
    "location": null,
    "repeated": 0,
    "approved": 1,
    "deleted": 0,
    "voiceover": 0,
    "RunOrder": 1,
    "CreatedTime": "2025-02-07T06:53:16.000Z",
    "ScriptLastModifiedTime": "2025-02-07T06:55:51.000Z",
    "Approval": 1,
    "MediaInsert": null,
    "DropStory": 0
};

export const languages = [
    "en-US",
    "hi-IN",
    "te-IN",
    "ta-IN",
    "mr-IN",
    "gu-IN",
    "kn-IN",
    "ml-IN",
    "pa-Guru-IN",
    "ur-IN",
    "ar-SA",
    "bn-BD",
    "bn-IN",
    "cs-CZ",
    "da-DK",
    "de-AT",
    "de-CH",
    "de-DE",
    "el-GR",
    "en-AU",
    "en-CA",
    "en-GB",
    "en-IE",
    "en-IN",
    "en-NZ",
    "en-US",
    "en-ZA",
    "es-AR",
    "es-CL",
    "es-CO",
    "es-ES",
    "es-MX",
    "es-US",
    "fi-FI",
    "fr-BE",
    "fr-CA",
    "fr-CH",
    "fr-FR",
    "he-IL",
    "hi-IN",
    "hu-HU",
    "id-ID",
    "it-CH",
    "it-IT",
    "jp-JP",
    "ko-KR",
    "nl-BE",
    "nl-NL",
    "no-NO",
    "pl-PL",
    "pt-BR",
    "pt-PT",
    "ro-RO",
    "ru-RU",
    "sk-SK",
    "sv-SE",
    "ta-IN",
    "ta-LK",
    "th-TH",
    "tr-TR",
    "ur_PK",
    "zh-CN",
    "zh-HK",
    "zh-TW",
    "bh-IN"
];

export const list_voices = [
    {
        "code": "af-ZA",
        "name": "af-ZA-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "am-ET",
        "name": "am-ET-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "am-ET",
        "name": "am-ET-Standard-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "am-ET",
        "name": "am-ET-Wavenet-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "am-ET",
        "name": "am-ET-Wavenet-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "ar-XA",
        "name": "ar-XA-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "ar-XA",
        "name": "ar-XA-Standard-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "ar-XA",
        "name": "ar-XA-Standard-C",
        "ssmlGender": "MALE"
    },
    {
        "code": "ar-XA",
        "name": "ar-XA-Standard-D",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "ar-XA",
        "name": "ar-XA-Wavenet-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "ar-XA",
        "name": "ar-XA-Wavenet-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "ar-XA",
        "name": "ar-XA-Wavenet-C",
        "ssmlGender": "MALE"
    },
    {
        "code": "ar-XA",
        "name": "ar-XA-Wavenet-D",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "bg-BG",
        "name": "bg-BG-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "bg-BG",
        "name": "bg-BG-Standard-B",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "bg-BG",
        "name": "bg-BG-Wavenet-B",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "bn-IN",
        "name": "bn-IN-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "bn-IN",
        "name": "bn-IN-Standard-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "bn-IN",
        "name": "bn-IN-Standard-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "bn-IN",
        "name": "bn-IN-Standard-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "bn-IN",
        "name": "bn-IN-Wavenet-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "bn-IN",
        "name": "bn-IN-Wavenet-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "bn-IN",
        "name": "bn-IN-Wavenet-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "bn-IN",
        "name": "bn-IN-Wavenet-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "ca-ES",
        "name": "ca-ES-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "ca-ES",
        "name": "ca-ES-Standard-B",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "ca-ES",
        "name": "ca-ES-Wavenet-B",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "cmn-CN",
        "name": "cmn-CN-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "cmn-CN",
        "name": "cmn-CN-Standard-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "cmn-CN",
        "name": "cmn-CN-Standard-C",
        "ssmlGender": "MALE"
    },
    {
        "code": "cmn-CN",
        "name": "cmn-CN-Standard-D",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "cmn-CN",
        "name": "cmn-CN-Wavenet-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "cmn-CN",
        "name": "cmn-CN-Wavenet-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "cmn-CN",
        "name": "cmn-CN-Wavenet-C",
        "ssmlGender": "MALE"
    },
    {
        "code": "cmn-CN",
        "name": "cmn-CN-Wavenet-D",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "cmn-TW",
        "name": "cmn-TW-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "cmn-TW",
        "name": "cmn-TW-Standard-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "cmn-TW",
        "name": "cmn-TW-Standard-C",
        "ssmlGender": "MALE"
    },
    {
        "code": "cmn-TW",
        "name": "cmn-TW-Wavenet-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "cmn-TW",
        "name": "cmn-TW-Wavenet-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "cmn-TW",
        "name": "cmn-TW-Wavenet-C",
        "ssmlGender": "MALE"
    },
    {
        "code": "cs-CZ",
        "name": "cs-CZ-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "cs-CZ",
        "name": "cs-CZ-Standard-B",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "cs-CZ",
        "name": "cs-CZ-Wavenet-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "cs-CZ",
        "name": "cs-CZ-Wavenet-B",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "da-DK",
        "name": "da-DK-Neural2-D",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "da-DK",
        "name": "da-DK-Neural2-F",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "da-DK",
        "name": "da-DK-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "da-DK",
        "name": "da-DK-Standard-C",
        "ssmlGender": "MALE"
    },
    {
        "code": "da-DK",
        "name": "da-DK-Standard-D",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "da-DK",
        "name": "da-DK-Standard-E",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "da-DK",
        "name": "da-DK-Standard-F",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "da-DK",
        "name": "da-DK-Standard-G",
        "ssmlGender": "MALE"
    },
    {
        "code": "da-DK",
        "name": "da-DK-Wavenet-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "da-DK",
        "name": "da-DK-Wavenet-C",
        "ssmlGender": "MALE"
    },
    {
        "code": "da-DK",
        "name": "da-DK-Wavenet-D",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "da-DK",
        "name": "da-DK-Wavenet-E",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "da-DK",
        "name": "da-DK-Wavenet-F",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "da-DK",
        "name": "da-DK-Wavenet-G",
        "ssmlGender": "MALE"
    },
    {
        "code": "de-DE",
        "name": "de-DE-Journey-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "de-DE",
        "name": "de-DE-Journey-F",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "de-DE",
        "name": "de-DE-Journey-O",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "de-DE",
        "name": "de-DE-Neural2-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "de-DE",
        "name": "de-DE-Neural2-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "de-DE",
        "name": "de-DE-Neural2-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "de-DE",
        "name": "de-DE-Neural2-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "de-DE",
        "name": "de-DE-Neural2-F",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "de-DE",
        "name": "de-DE-Neural2-G",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "de-DE",
        "name": "de-DE-Neural2-H",
        "ssmlGender": "MALE"
    },
    {
        "code": "de-DE",
        "name": "de-DE-Polyglot-1",
        "ssmlGender": "MALE"
    },
    {
        "code": "de-DE",
        "name": "de-DE-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "de-DE",
        "name": "de-DE-Standard-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "de-DE",
        "name": "de-DE-Standard-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "de-DE",
        "name": "de-DE-Standard-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "de-DE",
        "name": "de-DE-Standard-E",
        "ssmlGender": "MALE"
    },
    {
        "code": "de-DE",
        "name": "de-DE-Standard-F",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "de-DE",
        "name": "de-DE-Standard-G",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "de-DE",
        "name": "de-DE-Standard-H",
        "ssmlGender": "MALE"
    },
    {
        "code": "de-DE",
        "name": "de-DE-Studio-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "de-DE",
        "name": "de-DE-Studio-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "de-DE",
        "name": "de-DE-Wavenet-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "de-DE",
        "name": "de-DE-Wavenet-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "de-DE",
        "name": "de-DE-Wavenet-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "de-DE",
        "name": "de-DE-Wavenet-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "de-DE",
        "name": "de-DE-Wavenet-E",
        "ssmlGender": "MALE"
    },
    {
        "code": "de-DE",
        "name": "de-DE-Wavenet-F",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "de-DE",
        "name": "de-DE-Wavenet-G",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "de-DE",
        "name": "de-DE-Wavenet-H",
        "ssmlGender": "MALE"
    },
    {
        "code": "el-GR",
        "name": "el-GR-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "el-GR",
        "name": "el-GR-Standard-B",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "el-GR",
        "name": "el-GR-Wavenet-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "el-GR",
        "name": "el-GR-Wavenet-B",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-AU",
        "name": "en-AU-Journey-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-AU",
        "name": "en-AU-Journey-F",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-AU",
        "name": "en-AU-Journey-O",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-AU",
        "name": "en-AU-Neural2-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-AU",
        "name": "en-AU-Neural2-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-AU",
        "name": "en-AU-Neural2-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-AU",
        "name": "en-AU-Neural2-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-AU",
        "name": "en-AU-News-E",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-AU",
        "name": "en-AU-News-F",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-AU",
        "name": "en-AU-News-G",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-AU",
        "name": "en-AU-Polyglot-1",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-AU",
        "name": "en-AU-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-AU",
        "name": "en-AU-Standard-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-AU",
        "name": "en-AU-Standard-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-AU",
        "name": "en-AU-Standard-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-AU",
        "name": "en-AU-Wavenet-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-AU",
        "name": "en-AU-Wavenet-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-AU",
        "name": "en-AU-Wavenet-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-AU",
        "name": "en-AU-Wavenet-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-GB",
        "name": "en-GB-Journey-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-GB",
        "name": "en-GB-Journey-F",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-GB",
        "name": "en-GB-Journey-O",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-GB",
        "name": "en-GB-Neural2-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-GB",
        "name": "en-GB-Neural2-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-GB",
        "name": "en-GB-Neural2-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-GB",
        "name": "en-GB-Neural2-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-GB",
        "name": "en-GB-Neural2-F",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-GB",
        "name": "en-GB-Neural2-N",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-GB",
        "name": "en-GB-Neural2-O",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-GB",
        "name": "en-GB-News-G",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-GB",
        "name": "en-GB-News-H",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-GB",
        "name": "en-GB-News-I",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-GB",
        "name": "en-GB-News-J",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-GB",
        "name": "en-GB-News-K",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-GB",
        "name": "en-GB-News-L",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-GB",
        "name": "en-GB-News-M",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-GB",
        "name": "en-GB-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-GB",
        "name": "en-GB-Standard-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-GB",
        "name": "en-GB-Standard-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-GB",
        "name": "en-GB-Standard-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-GB",
        "name": "en-GB-Standard-F",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-GB",
        "name": "en-GB-Standard-N",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-GB",
        "name": "en-GB-Standard-O",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-GB",
        "name": "en-GB-Studio-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-GB",
        "name": "en-GB-Studio-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-GB",
        "name": "en-GB-Wavenet-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-GB",
        "name": "en-GB-Wavenet-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-GB",
        "name": "en-GB-Wavenet-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-GB",
        "name": "en-GB-Wavenet-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-GB",
        "name": "en-GB-Wavenet-F",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-GB",
        "name": "en-GB-Wavenet-N",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-GB",
        "name": "en-GB-Wavenet-O",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-IN",
        "name": "en-IN-Journey-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-IN",
        "name": "en-IN-Journey-F",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-IN",
        "name": "en-IN-Journey-O",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-IN",
        "name": "en-IN-Neural2-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-IN",
        "name": "en-IN-Neural2-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-IN",
        "name": "en-IN-Neural2-C",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-IN",
        "name": "en-IN-Neural2-D",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-IN",
        "name": "en-IN-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-IN",
        "name": "en-IN-Standard-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-IN",
        "name": "en-IN-Standard-C",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-IN",
        "name": "en-IN-Standard-D",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-IN",
        "name": "en-IN-Standard-E",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-IN",
        "name": "en-IN-Standard-F",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-IN",
        "name": "en-IN-Wavenet-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-IN",
        "name": "en-IN-Wavenet-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-IN",
        "name": "en-IN-Wavenet-C",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-IN",
        "name": "en-IN-Wavenet-D",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-IN",
        "name": "en-IN-Wavenet-E",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-IN",
        "name": "en-IN-Wavenet-F",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-US",
        "name": "en-US-Casual-K",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-US",
        "name": "en-US-Journey-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-US",
        "name": "en-US-Journey-F",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-US",
        "name": "en-US-Journey-O",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-US",
        "name": "en-US-Neural2-A",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-US",
        "name": "en-US-Neural2-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-US",
        "name": "en-US-Neural2-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-US",
        "name": "en-US-Neural2-E",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-US",
        "name": "en-US-Neural2-F",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-US",
        "name": "en-US-Neural2-G",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-US",
        "name": "en-US-Neural2-H",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-US",
        "name": "en-US-Neural2-I",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-US",
        "name": "en-US-Neural2-J",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-US",
        "name": "en-US-News-K",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-US",
        "name": "en-US-News-L",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-US",
        "name": "en-US-News-N",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-US",
        "name": "en-US-Polyglot-1",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-US",
        "name": "en-US-Standard-A",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-US",
        "name": "en-US-Standard-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-US",
        "name": "en-US-Standard-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-US",
        "name": "en-US-Standard-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-US",
        "name": "en-US-Standard-E",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-US",
        "name": "en-US-Standard-F",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-US",
        "name": "en-US-Standard-G",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-US",
        "name": "en-US-Standard-H",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-US",
        "name": "en-US-Standard-I",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-US",
        "name": "en-US-Standard-J",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-US",
        "name": "en-US-Studio-O",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-US",
        "name": "en-US-Studio-Q",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-US",
        "name": "en-US-Wavenet-A",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-US",
        "name": "en-US-Wavenet-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-US",
        "name": "en-US-Wavenet-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-US",
        "name": "en-US-Wavenet-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-US",
        "name": "en-US-Wavenet-E",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-US",
        "name": "en-US-Wavenet-F",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-US",
        "name": "en-US-Wavenet-G",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-US",
        "name": "en-US-Wavenet-H",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "en-US",
        "name": "en-US-Wavenet-I",
        "ssmlGender": "MALE"
    },
    {
        "code": "en-US",
        "name": "en-US-Wavenet-J",
        "ssmlGender": "MALE"
    },
    {
        "code": "es-ES",
        "name": "es-ES-Journey-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "es-ES",
        "name": "es-ES-Journey-F",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "es-ES",
        "name": "es-ES-Journey-O",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "es-ES",
        "name": "es-ES-Neural2-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "es-ES",
        "name": "es-ES-Neural2-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "es-ES",
        "name": "es-ES-Neural2-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "es-ES",
        "name": "es-ES-Neural2-D",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "es-ES",
        "name": "es-ES-Neural2-E",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "es-ES",
        "name": "es-ES-Neural2-F",
        "ssmlGender": "MALE"
    },
    {
        "code": "es-ES",
        "name": "es-ES-Neural2-G",
        "ssmlGender": "MALE"
    },
    {
        "code": "es-ES",
        "name": "es-ES-Neural2-H",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "es-ES",
        "name": "es-ES-Polyglot-1",
        "ssmlGender": "MALE"
    },
    {
        "code": "es-ES",
        "name": "es-ES-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "es-ES",
        "name": "es-ES-Standard-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "es-ES",
        "name": "es-ES-Standard-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "es-ES",
        "name": "es-ES-Standard-D",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "es-ES",
        "name": "es-ES-Standard-E",
        "ssmlGender": "MALE"
    },
    {
        "code": "es-ES",
        "name": "es-ES-Standard-F",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "es-ES",
        "name": "es-ES-Standard-G",
        "ssmlGender": "MALE"
    },
    {
        "code": "es-ES",
        "name": "es-ES-Standard-H",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "es-ES",
        "name": "es-ES-Studio-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "es-ES",
        "name": "es-ES-Studio-F",
        "ssmlGender": "MALE"
    },
    {
        "code": "es-ES",
        "name": "es-ES-Wavenet-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "es-ES",
        "name": "es-ES-Wavenet-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "es-ES",
        "name": "es-ES-Wavenet-D",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "es-ES",
        "name": "es-ES-Wavenet-E",
        "ssmlGender": "MALE"
    },
    {
        "code": "es-ES",
        "name": "es-ES-Wavenet-F",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "es-ES",
        "name": "es-ES-Wavenet-G",
        "ssmlGender": "MALE"
    },
    {
        "code": "es-ES",
        "name": "es-ES-Wavenet-H",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "es-US",
        "name": "es-US-Journey-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "es-US",
        "name": "es-US-Journey-F",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "es-US",
        "name": "es-US-Journey-O",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "es-US",
        "name": "es-US-Neural2-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "es-US",
        "name": "es-US-Neural2-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "es-US",
        "name": "es-US-Neural2-C",
        "ssmlGender": "MALE"
    },
    {
        "code": "es-US",
        "name": "es-US-News-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "es-US",
        "name": "es-US-News-E",
        "ssmlGender": "MALE"
    },
    {
        "code": "es-US",
        "name": "es-US-News-F",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "es-US",
        "name": "es-US-News-G",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "es-US",
        "name": "es-US-Polyglot-1",
        "ssmlGender": "MALE"
    },
    {
        "code": "es-US",
        "name": "es-US-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "es-US",
        "name": "es-US-Standard-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "es-US",
        "name": "es-US-Standard-C",
        "ssmlGender": "MALE"
    },
    {
        "code": "es-US",
        "name": "es-US-Studio-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "es-US",
        "name": "es-US-Wavenet-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "es-US",
        "name": "es-US-Wavenet-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "es-US",
        "name": "es-US-Wavenet-C",
        "ssmlGender": "MALE"
    },
    {
        "code": "et-EE",
        "name": "et-EE-Standard-A",
        "ssmlGender": "MALE"
    },
    {
        "code": "eu-ES",
        "name": "eu-ES-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "eu-ES",
        "name": "eu-ES-Standard-B",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "eu-ES",
        "name": "eu-ES-Wavenet-B",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "fi-FI",
        "name": "fi-FI-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "fi-FI",
        "name": "fi-FI-Standard-B",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "fi-FI",
        "name": "fi-FI-Wavenet-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "fi-FI",
        "name": "fi-FI-Wavenet-B",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "fil-PH",
        "name": "fil-PH-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "fil-PH",
        "name": "fil-PH-Standard-B",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "fil-PH",
        "name": "fil-PH-Standard-C",
        "ssmlGender": "MALE"
    },
    {
        "code": "fil-PH",
        "name": "fil-PH-Standard-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "fil-PH",
        "name": "fil-PH-Wavenet-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "fil-PH",
        "name": "fil-PH-Wavenet-B",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "fil-PH",
        "name": "fil-PH-Wavenet-C",
        "ssmlGender": "MALE"
    },
    {
        "code": "fil-PH",
        "name": "fil-PH-Wavenet-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "fil-PH",
        "name": "fil-ph-Neural2-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "fil-PH",
        "name": "fil-ph-Neural2-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "fr-CA",
        "name": "fr-CA-Journey-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "fr-CA",
        "name": "fr-CA-Journey-F",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "fr-CA",
        "name": "fr-CA-Journey-O",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "fr-CA",
        "name": "fr-CA-Neural2-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "fr-CA",
        "name": "fr-CA-Neural2-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "fr-CA",
        "name": "fr-CA-Neural2-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "fr-CA",
        "name": "fr-CA-Neural2-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "fr-CA",
        "name": "fr-CA-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "fr-CA",
        "name": "fr-CA-Standard-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "fr-CA",
        "name": "fr-CA-Standard-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "fr-CA",
        "name": "fr-CA-Standard-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "fr-CA",
        "name": "fr-CA-Wavenet-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "fr-CA",
        "name": "fr-CA-Wavenet-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "fr-CA",
        "name": "fr-CA-Wavenet-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "fr-CA",
        "name": "fr-CA-Wavenet-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "fr-FR",
        "name": "fr-FR-Journey-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "fr-FR",
        "name": "fr-FR-Journey-F",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "fr-FR",
        "name": "fr-FR-Journey-O",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "fr-FR",
        "name": "fr-FR-Neural2-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "fr-FR",
        "name": "fr-FR-Neural2-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "fr-FR",
        "name": "fr-FR-Neural2-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "fr-FR",
        "name": "fr-FR-Neural2-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "fr-FR",
        "name": "fr-FR-Neural2-E",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "fr-FR",
        "name": "fr-FR-Neural2-F",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "fr-FR",
        "name": "fr-FR-Neural2-G",
        "ssmlGender": "MALE"
    },
    {
        "code": "fr-FR",
        "name": "fr-FR-Polyglot-1",
        "ssmlGender": "MALE"
    },
    {
        "code": "fr-FR",
        "name": "fr-FR-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "fr-FR",
        "name": "fr-FR-Standard-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "fr-FR",
        "name": "fr-FR-Standard-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "fr-FR",
        "name": "fr-FR-Standard-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "fr-FR",
        "name": "fr-FR-Standard-E",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "fr-FR",
        "name": "fr-FR-Standard-F",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "fr-FR",
        "name": "fr-FR-Standard-G",
        "ssmlGender": "MALE"
    },
    {
        "code": "fr-FR",
        "name": "fr-FR-Studio-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "fr-FR",
        "name": "fr-FR-Studio-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "fr-FR",
        "name": "fr-FR-Wavenet-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "fr-FR",
        "name": "fr-FR-Wavenet-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "fr-FR",
        "name": "fr-FR-Wavenet-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "fr-FR",
        "name": "fr-FR-Wavenet-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "fr-FR",
        "name": "fr-FR-Wavenet-E",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "fr-FR",
        "name": "fr-FR-Wavenet-F",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "fr-FR",
        "name": "fr-FR-Wavenet-G",
        "ssmlGender": "MALE"
    },
    {
        "code": "gl-ES",
        "name": "gl-ES-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "gl-ES",
        "name": "gl-ES-Standard-B",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "gl-ES",
        "name": "gl-ES-Wavenet-B",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "gu-IN",
        "name": "gu-IN-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "gu-IN",
        "name": "gu-IN-Standard-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "gu-IN",
        "name": "gu-IN-Standard-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "gu-IN",
        "name": "gu-IN-Standard-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "gu-IN",
        "name": "gu-IN-Wavenet-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "gu-IN",
        "name": "gu-IN-Wavenet-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "gu-IN",
        "name": "gu-IN-Wavenet-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "gu-IN",
        "name": "gu-IN-Wavenet-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "he-IL",
        "name": "he-IL-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "he-IL",
        "name": "he-IL-Standard-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "he-IL",
        "name": "he-IL-Standard-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "he-IL",
        "name": "he-IL-Standard-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "he-IL",
        "name": "he-IL-Wavenet-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "he-IL",
        "name": "he-IL-Wavenet-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "he-IL",
        "name": "he-IL-Wavenet-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "he-IL",
        "name": "he-IL-Wavenet-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "hi-IN",
        "name": "hi-IN-Neural2-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "hi-IN",
        "name": "hi-IN-Neural2-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "hi-IN",
        "name": "hi-IN-Neural2-C",
        "ssmlGender": "MALE"
    },
    {
        "code": "hi-IN",
        "name": "hi-IN-Neural2-D",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "hi-IN",
        "name": "hi-IN-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "hi-IN",
        "name": "hi-IN-Standard-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "hi-IN",
        "name": "hi-IN-Standard-C",
        "ssmlGender": "MALE"
    },
    {
        "code": "hi-IN",
        "name": "hi-IN-Standard-D",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "hi-IN",
        "name": "hi-IN-Standard-E",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "hi-IN",
        "name": "hi-IN-Standard-F",
        "ssmlGender": "MALE"
    },
    {
        "code": "hi-IN",
        "name": "hi-IN-Wavenet-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "hi-IN",
        "name": "hi-IN-Wavenet-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "hi-IN",
        "name": "hi-IN-Wavenet-C",
        "ssmlGender": "MALE"
    },
    {
        "code": "hi-IN",
        "name": "hi-IN-Wavenet-D",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "hi-IN",
        "name": "hi-IN-Wavenet-E",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "hi-IN",
        "name": "hi-IN-Wavenet-F",
        "ssmlGender": "MALE"
    },
    {
        "code": "hu-HU",
        "name": "hu-HU-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "hu-HU",
        "name": "hu-HU-Standard-B",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "hu-HU",
        "name": "hu-HU-Wavenet-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "hu-HU",
        "name": "hu-HU-Wavenet-B",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "id-ID",
        "name": "id-ID-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "id-ID",
        "name": "id-ID-Standard-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "id-ID",
        "name": "id-ID-Standard-C",
        "ssmlGender": "MALE"
    },
    {
        "code": "id-ID",
        "name": "id-ID-Standard-D",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "id-ID",
        "name": "id-ID-Wavenet-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "id-ID",
        "name": "id-ID-Wavenet-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "id-ID",
        "name": "id-ID-Wavenet-C",
        "ssmlGender": "MALE"
    },
    {
        "code": "id-ID",
        "name": "id-ID-Wavenet-D",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "is-IS",
        "name": "is-IS-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "is-IS",
        "name": "is-IS-Standard-B",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "is-IS",
        "name": "is-IS-Wavenet-B",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "it-IT",
        "name": "it-IT-Journey-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "it-IT",
        "name": "it-IT-Journey-F",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "it-IT",
        "name": "it-IT-Journey-O",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "it-IT",
        "name": "it-IT-Neural2-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "it-IT",
        "name": "it-IT-Neural2-C",
        "ssmlGender": "MALE"
    },
    {
        "code": "it-IT",
        "name": "it-IT-Neural2-F",
        "ssmlGender": "MALE"
    },
    {
        "code": "it-IT",
        "name": "it-IT-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "it-IT",
        "name": "it-IT-Standard-B",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "it-IT",
        "name": "it-IT-Standard-C",
        "ssmlGender": "MALE"
    },
    {
        "code": "it-IT",
        "name": "it-IT-Standard-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "it-IT",
        "name": "it-IT-Standard-E",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "it-IT",
        "name": "it-IT-Standard-F",
        "ssmlGender": "MALE"
    },
    {
        "code": "it-IT",
        "name": "it-IT-Wavenet-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "it-IT",
        "name": "it-IT-Wavenet-B",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "it-IT",
        "name": "it-IT-Wavenet-C",
        "ssmlGender": "MALE"
    },
    {
        "code": "it-IT",
        "name": "it-IT-Wavenet-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "it-IT",
        "name": "it-IT-Wavenet-E",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "it-IT",
        "name": "it-IT-Wavenet-F",
        "ssmlGender": "MALE"
    },
    {
        "code": "ja-JP",
        "name": "ja-JP-Neural2-B",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "ja-JP",
        "name": "ja-JP-Neural2-C",
        "ssmlGender": "MALE"
    },
    {
        "code": "ja-JP",
        "name": "ja-JP-Neural2-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "ja-JP",
        "name": "ja-JP-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "ja-JP",
        "name": "ja-JP-Standard-B",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "ja-JP",
        "name": "ja-JP-Standard-C",
        "ssmlGender": "MALE"
    },
    {
        "code": "ja-JP",
        "name": "ja-JP-Standard-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "ja-JP",
        "name": "ja-JP-Wavenet-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "ja-JP",
        "name": "ja-JP-Wavenet-B",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "ja-JP",
        "name": "ja-JP-Wavenet-C",
        "ssmlGender": "MALE"
    },
    {
        "code": "ja-JP",
        "name": "ja-JP-Wavenet-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "kn-IN",
        "name": "kn-IN-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "kn-IN",
        "name": "kn-IN-Standard-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "kn-IN",
        "name": "kn-IN-Standard-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "kn-IN",
        "name": "kn-IN-Standard-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "kn-IN",
        "name": "kn-IN-Wavenet-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "kn-IN",
        "name": "kn-IN-Wavenet-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "kn-IN",
        "name": "kn-IN-Wavenet-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "kn-IN",
        "name": "kn-IN-Wavenet-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "ko-KR",
        "name": "ko-KR-Neural2-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "ko-KR",
        "name": "ko-KR-Neural2-B",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "ko-KR",
        "name": "ko-KR-Neural2-C",
        "ssmlGender": "MALE"
    },
    {
        "code": "ko-KR",
        "name": "ko-KR-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "ko-KR",
        "name": "ko-KR-Standard-B",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "ko-KR",
        "name": "ko-KR-Standard-C",
        "ssmlGender": "MALE"
    },
    {
        "code": "ko-KR",
        "name": "ko-KR-Standard-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "ko-KR",
        "name": "ko-KR-Wavenet-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "ko-KR",
        "name": "ko-KR-Wavenet-B",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "ko-KR",
        "name": "ko-KR-Wavenet-C",
        "ssmlGender": "MALE"
    },
    {
        "code": "ko-KR",
        "name": "ko-KR-Wavenet-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "lt-LT",
        "name": "lt-LT-Standard-A",
        "ssmlGender": "MALE"
    },
    {
        "code": "lt-LT",
        "name": "lt-LT-Standard-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "lt-LT",
        "name": "lt-LT-Wavenet-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "lv-LV",
        "name": "lv-LV-Standard-A",
        "ssmlGender": "MALE"
    },
    {
        "code": "lv-LV",
        "name": "lv-LV-Standard-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "lt-LT",
        "name": "lv-LV-Wavenet-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "ml-IN",
        "name": "ml-IN-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "ml-IN",
        "name": "ml-IN-Standard-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "ml-IN",
        "name": "ml-IN-Standard-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "ml-IN",
        "name": "ml-IN-Standard-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "ml-IN",
        "name": "ml-IN-Wavenet-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "ml-IN",
        "name": "ml-IN-Wavenet-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "ml-IN",
        "name": "ml-IN-Wavenet-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "ml-IN",
        "name": "ml-IN-Wavenet-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "mr-IN",
        "name": "mr-IN-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "mr-IN",
        "name": "mr-IN-Standard-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "mr-IN",
        "name": "mr-IN-Standard-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "mr-IN",
        "name": "mr-IN-Wavenet-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "mr-IN",
        "name": "mr-IN-Wavenet-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "mr-IN",
        "name": "mr-IN-Wavenet-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "ms-MY",
        "name": "ms-MY-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "ms-MY",
        "name": "ms-MY-Standard-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "ms-MY",
        "name": "ms-MY-Standard-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "ms-MY",
        "name": "ms-MY-Standard-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "ms-MY",
        "name": "ms-MY-Wavenet-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "ms-MY",
        "name": "ms-MY-Wavenet-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "ms-MY",
        "name": "ms-MY-Wavenet-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "ms-MY",
        "name": "ms-MY-Wavenet-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "nb-NO",
        "name": "nb-NO-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "nb-NO",
        "name": "nb-NO-Standard-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "nb-NO",
        "name": "nb-NO-Standard-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "nb-NO",
        "name": "nb-NO-Standard-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "nb-NO",
        "name": "nb-NO-Standard-E",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "nb-NO",
        "name": "nb-NO-Standard-F",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "nb-NO",
        "name": "nb-NO-Standard-G",
        "ssmlGender": "MALE"
    },
    {
        "code": "nb-NO",
        "name": "nb-NO-Wavenet-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "nb-NO",
        "name": "nb-NO-Wavenet-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "nb-NO",
        "name": "nb-NO-Wavenet-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "nb-NO",
        "name": "nb-NO-Wavenet-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "nb-NO",
        "name": "nb-NO-Wavenet-E",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "nb-NO",
        "name": "nb-NO-Wavenet-F",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "nb-NO",
        "name": "nb-NO-Wavenet-G",
        "ssmlGender": "MALE"
    },
    {
        "code": "nl-BE",
        "name": "nl-BE-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "nl-BE",
        "name": "nl-BE-Standard-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "nl-BE",
        "name": "nl-BE-Standard-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "nl-BE",
        "name": "nl-BE-Standard-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "nl-BE",
        "name": "nl-BE-Wavenet-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "nl-BE",
        "name": "nl-BE-Wavenet-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "nl-BE",
        "name": "nl-BE-Wavenet-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "nl-BE",
        "name": "nl-BE-Wavenet-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "nl-NL",
        "name": "nl-NL-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "nl-NL",
        "name": "nl-NL-Standard-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "nl-NL",
        "name": "nl-NL-Standard-C",
        "ssmlGender": "MALE"
    },
    {
        "code": "nl-NL",
        "name": "nl-NL-Standard-D",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "nl-NL",
        "name": "nl-NL-Standard-E",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "nl-NL",
        "name": "nl-NL-Standard-F",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "nl-NL",
        "name": "nl-NL-Standard-G",
        "ssmlGender": "MALE"
    },
    {
        "code": "nl-NL",
        "name": "nl-NL-Wavenet-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "nl-NL",
        "name": "nl-NL-Wavenet-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "nl-NL",
        "name": "nl-NL-Wavenet-C",
        "ssmlGender": "MALE"
    },
    {
        "code": "nl-NL",
        "name": "nl-NL-Wavenet-D",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "nl-NL",
        "name": "nl-NL-Wavenet-E",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "nl-NL",
        "name": "nl-NL-Wavenet-F",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "nl-NL",
        "name": "nl-NL-Wavenet-G",
        "ssmlGender": "MALE"
    },
    {
        "code": "pa-IN",
        "name": "pa-IN-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "pa-IN",
        "name": "pa-IN-Standard-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "pa-IN",
        "name": "pa-IN-Standard-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "pa-IN",
        "name": "pa-IN-Standard-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "pa-IN",
        "name": "pa-IN-Wavenet-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "pa-IN",
        "name": "pa-IN-Wavenet-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "pa-IN",
        "name": "pa-IN-Wavenet-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "pa-IN",
        "name": "pa-IN-Wavenet-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "pl-PL",
        "name": "pl-PL-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "pl-PL",
        "name": "pl-PL-Standard-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "pl-PL",
        "name": "pl-PL-Standard-C",
        "ssmlGender": "MALE"
    },
    {
        "code": "pl-PL",
        "name": "pl-PL-Standard-D",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "pl-PL",
        "name": "pl-PL-Standard-E",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "pl-PL",
        "name": "pl-PL-Standard-F",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "pl-PL",
        "name": "pl-PL-Standard-G",
        "ssmlGender": "MALE"
    },
    {
        "code": "pl-PL",
        "name": "pl-PL-Wavenet-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "pl-PL",
        "name": "pl-PL-Wavenet-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "pl-PL",
        "name": "pl-PL-Wavenet-C",
        "ssmlGender": "MALE"
    },
    {
        "code": "pl-PL",
        "name": "pl-PL-Wavenet-D",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "pl-PL",
        "name": "pl-PL-Wavenet-E",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "pl-PL",
        "name": "pl-PL-Wavenet-F",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "pl-PL",
        "name": "pl-PL-Wavenet-G",
        "ssmlGender": "MALE"
    },
    {
        "code": "pt-BR",
        "name": "pt-BR-Neural2-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "pt-BR",
        "name": "pt-BR-Neural2-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "pt-BR",
        "name": "pt-BR-Neural2-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "pt-BR",
        "name": "pt-BR-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "pt-BR",
        "name": "pt-BR-Standard-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "pt-BR",
        "name": "pt-BR-Standard-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "pt-BR",
        "name": "pt-BR-Standard-D",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "pt-BR",
        "name": "pt-BR-Standard-E",
        "ssmlGender": "MALE"
    },
    {
        "code": "pt-BR",
        "name": "pt-BR-Wavenet-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "pt-BR",
        "name": "pt-BR-Wavenet-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "pt-BR",
        "name": "pt-BR-Wavenet-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "pt-BR",
        "name": "pt-BR-Wavenet-D",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "pt-BR",
        "name": "pt-BR-Wavenet-E",
        "ssmlGender": "MALE"
    },
    {
        "code": "pt-PT",
        "name": "pt-PT-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "pt-PT",
        "name": "pt-PT-Standard-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "pt-PT",
        "name": "pt-PT-Standard-C",
        "ssmlGender": "MALE"
    },
    {
        "code": "pt-PT",
        "name": "pt-PT-Standard-D",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "pt-PT",
        "name": "pt-PT-Standard-E",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "pt-PT",
        "name": "pt-PT-Standard-F",
        "ssmlGender": "MALE"
    },
    {
        "code": "pt-PT",
        "name": "pt-PT-Wavenet-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "pt-PT",
        "name": "pt-PT-Wavenet-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "pt-PT",
        "name": "pt-PT-Wavenet-C",
        "ssmlGender": "MALE"
    },
    {
        "code": "pt-PT",
        "name": "pt-PT-Wavenet-D",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "pt-PT",
        "name": "pt-PT-Wavenet-E",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "pt-PT",
        "name": "pt-PT-Wavenet-F",
        "ssmlGender": "MALE"
    },
    {
        "code": "ro-RO",
        "name": "ro-RO-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "ro-RO",
        "name": "ro-RO-Standard-B",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "ro-RO",
        "name": "ro-RO-Wavenet-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "ro-RO",
        "name": "ro-RO-Wavenet-B",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "ru-RU",
        "name": "ru-RU-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "ru-RU",
        "name": "ru-RU-Standard-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "ru-RU",
        "name": "ru-RU-Standard-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "ru-RU",
        "name": "ru-RU-Standard-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "ru-RU",
        "name": "ru-RU-Standard-E",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "ru-RU",
        "name": "ru-RU-Wavenet-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "ru-RU",
        "name": "ru-RU-Wavenet-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "ru-RU",
        "name": "ru-RU-Wavenet-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "ru-RU",
        "name": "ru-RU-Wavenet-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "ru-RU",
        "name": "ru-RU-Wavenet-E",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "sk-SK",
        "name": "sk-SK-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "sk-SK",
        "name": "sk-SK-Standard-B",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "sk-SK",
        "name": "sk-SK-Wavenet-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "sk-SK",
        "name": "sk-SK-Wavenet-B",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "sr-RS",
        "name": "sr-RS-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "sv-SE",
        "name": "sv-SE-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "sv-SE",
        "name": "sv-SE-Standard-B",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "sv-SE",
        "name": "sv-SE-Standard-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "sv-SE",
        "name": "sv-SE-Standard-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "sv-SE",
        "name": "sv-SE-Standard-E",
        "ssmlGender": "MALE"
    },
    {
        "code": "sv-SE",
        "name": "sv-SE-Standard-F",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "sv-SE",
        "name": "sv-SE-Standard-G",
        "ssmlGender": "MALE"
    },
    {
        "code": "sv-SE",
        "name": "sv-SE-Wavenet-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "sv-SE",
        "name": "sv-SE-Wavenet-B",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "sv-SE",
        "name": "sv-SE-Wavenet-C",
        "ssmlGender": "MALE"
    },
    {
        "code": "sv-SE",
        "name": "sv-SE-Wavenet-D",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "sv-SE",
        "name": "sv-SE-Wavenet-E",
        "ssmlGender": "MALE"
    },
    {
        "code": "sv-SE",
        "name": "sv-SE-Wavenet-F",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "sv-SE",
        "name": "sv-SE-Wavenet-G",
        "ssmlGender": "MALE"
    },
    {
        "code": "ta-IN",
        "name": "ta-IN-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "ta-IN",
        "name": "ta-IN-Standard-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "ta-IN",
        "name": "ta-IN-Standard-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "ta-IN",
        "name": "ta-IN-Standard-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "ta-IN",
        "name": "ta-IN-Wavenet-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "ta-IN",
        "name": "ta-IN-Wavenet-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "ta-IN",
        "name": "ta-IN-Wavenet-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "ta-IN",
        "name": "ta-IN-Wavenet-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "te-IN",
        "name": "te-IN-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "te-IN",
        "name": "te-IN-Standard-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "te-IN",
        "name": "te-IN-Standard-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "te-IN",
        "name": "te-IN-Standard-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "th-TH",
        "name": "th-TH-Neural2-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "th-TH",
        "name": "th-TH-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "tr-TR",
        "name": "tr-TR-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "tr-TR",
        "name": "tr-TR-Standard-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "tr-TR",
        "name": "tr-TR-Standard-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "tr-TR",
        "name": "tr-TR-Standard-D",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "tr-TR",
        "name": "tr-TR-Standard-E",
        "ssmlGender": "MALE"
    },
    {
        "code": "tr-TR",
        "name": "tr-TR-Wavenet-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "tr-TR",
        "name": "tr-TR-Wavenet-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "tr-TR",
        "name": "tr-TR-Wavenet-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "tr-TR",
        "name": "tr-TR-Wavenet-D",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "tr-TR",
        "name": "tr-TR-Wavenet-E",
        "ssmlGender": "MALE"
    },
    {
        "code": "uk-UA",
        "name": "uk-UA-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "uk-UA",
        "name": "uk-UA-Wavenet-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "ur-IN",
        "name": "ur-IN-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "ur-IN",
        "name": "ur-IN-Standard-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "ur-IN",
        "name": "ur-IN-Wavenet-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "ur-IN",
        "name": "ur-IN-Wavenet-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "vi-VN",
        "name": "vi-VN-Neural2-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "vi-VN",
        "name": "vi-VN-Neural2-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "vi-VN",
        "name": "vi-VN-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "vi-VN",
        "name": "vi-VN-Standard-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "vi-VN",
        "name": "vi-VN-Standard-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "vi-VN",
        "name": "vi-VN-Standard-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "vi-VN",
        "name": "vi-VN-Wavenet-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "vi-VN",
        "name": "vi-VN-Wavenet-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "vi-VN",
        "name": "vi-VN-Wavenet-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "vi-VN",
        "name": "vi-VN-Wavenet-D",
        "ssmlGender": "MALE"
    },
    {
        "code": "yue-HK",
        "name": "yue-HK-Standard-A",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "yue-HK",
        "name": "yue-HK-Standard-B",
        "ssmlGender": "MALE"
    },
    {
        "code": "yue-HK",
        "name": "yue-HK-Standard-C",
        "ssmlGender": "FEMALE"
    },
    {
        "code": "yue-HK",
        "name": "yue-HK-Standard-D",
        "ssmlGender": "MALE"
    }
]

export const languagelist = [
    {
        "code": "ab",
        "name": ""
    },
    {
        "code": "ace",
        "name": ""
    },
    {
        "code": "ach",
        "name": ""
    },
    {
        "code": "af",
        "name": ""
    },
    {
        "code": "ak",
        "name": ""
    },
    {
        "code": "alz",
        "name": ""
    },
    {
        "code": "am",
        "name": ""
    },
    {
        "code": "ar",
        "name": ""
    },
    {
        "code": "as",
        "name": ""
    },
    {
        "code": "awa",
        "name": ""
    },
    {
        "code": "ay",
        "name": ""
    },
    {
        "code": "az",
        "name": ""
    },
    {
        "code": "ba",
        "name": ""
    },
    {
        "code": "ban",
        "name": ""
    },
    {
        "code": "bbc",
        "name": ""
    },
    {
        "code": "be",
        "name": ""
    },
    {
        "code": "bem",
        "name": ""
    },
    {
        "code": "bew",
        "name": ""
    },
    {
        "code": "bg",
        "name": ""
    },
    {
        "code": "bho",
        "name": ""
    },
    {
        "code": "bik",
        "name": ""
    },
    {
        "code": "bm",
        "name": ""
    },
    {
        "code": "bn",
        "name": ""
    },
    {
        "code": "br",
        "name": ""
    },
    {
        "code": "bs",
        "name": ""
    },
    {
        "code": "bts",
        "name": ""
    },
    {
        "code": "btx",
        "name": ""
    },
    {
        "code": "bua",
        "name": ""
    },
    {
        "code": "ca",
        "name": ""
    },
    {
        "code": "ceb",
        "name": ""
    },
    {
        "code": "cgg",
        "name": ""
    },
    {
        "code": "chm",
        "name": ""
    },
    {
        "code": "ckb",
        "name": ""
    },
    {
        "code": "cnh",
        "name": ""
    },
    {
        "code": "co",
        "name": ""
    },
    {
        "code": "crh",
        "name": ""
    },
    {
        "code": "crs",
        "name": ""
    },
    {
        "code": "cs",
        "name": ""
    },
    {
        "code": "cv",
        "name": ""
    },
    {
        "code": "cy",
        "name": ""
    },
    {
        "code": "da",
        "name": ""
    },
    {
        "code": "de",
        "name": ""
    },
    {
        "code": "din",
        "name": ""
    },
    {
        "code": "doi",
        "name": ""
    },
    {
        "code": "dov",
        "name": ""
    },
    {
        "code": "dv",
        "name": ""
    },
    {
        "code": "dz",
        "name": ""
    },
    {
        "code": "ee",
        "name": ""
    },
    {
        "code": "el",
        "name": ""
    },
    {
        "code": "en",
        "name": ""
    },
    {
        "code": "eo",
        "name": ""
    },
    {
        "code": "es",
        "name": ""
    },
    {
        "code": "et",
        "name": ""
    },
    {
        "code": "eu",
        "name": ""
    },
    {
        "code": "fa",
        "name": ""
    },
    {
        "code": "ff",
        "name": ""
    },
    {
        "code": "fi",
        "name": ""
    },
    {
        "code": "fil",
        "name": ""
    },
    {
        "code": "fj",
        "name": ""
    },
    {
        "code": "fr",
        "name": ""
    },
    {
        "code": "fy",
        "name": ""
    },
    {
        "code": "ga",
        "name": ""
    },
    {
        "code": "gaa",
        "name": ""
    },
    {
        "code": "gd",
        "name": ""
    },
    {
        "code": "gl",
        "name": ""
    },
    {
        "code": "gn",
        "name": ""
    },
    {
        "code": "gom",
        "name": ""
    },
    {
        "code": "gu",
        "name": ""
    },
    {
        "code": "ha",
        "name": ""
    },
    {
        "code": "haw",
        "name": ""
    },
    {
        "code": "he",
        "name": ""
    },
    {
        "code": "hi",
        "name": ""
    },
    {
        "code": "hil",
        "name": ""
    },
    {
        "code": "hmn",
        "name": ""
    },
    {
        "code": "hr",
        "name": ""
    },
    {
        "code": "hrx",
        "name": ""
    },
    {
        "code": "ht",
        "name": ""
    },
    {
        "code": "hu",
        "name": ""
    },
    {
        "code": "hy",
        "name": ""
    },
    {
        "code": "id",
        "name": ""
    },
    {
        "code": "ig",
        "name": ""
    },
    {
        "code": "ilo",
        "name": ""
    },
    {
        "code": "is",
        "name": ""
    },
    {
        "code": "it",
        "name": ""
    },
    {
        "code": "iw",
        "name": ""
    },
    {
        "code": "ja",
        "name": ""
    },
    {
        "code": "jv",
        "name": ""
    },
    {
        "code": "jw",
        "name": ""
    },
    {
        "code": "ka",
        "name": ""
    },
    {
        "code": "kk",
        "name": ""
    },
    {
        "code": "km",
        "name": ""
    },
    {
        "code": "kn",
        "name": ""
    },
    {
        "code": "ko",
        "name": ""
    },
    {
        "code": "kri",
        "name": ""
    },
    {
        "code": "ktu",
        "name": ""
    },
    {
        "code": "ku",
        "name": ""
    },
    {
        "code": "ky",
        "name": ""
    },
    {
        "code": "la",
        "name": ""
    },
    {
        "code": "lb",
        "name": ""
    },
    {
        "code": "lg",
        "name": ""
    },
    {
        "code": "li",
        "name": ""
    },
    {
        "code": "lij",
        "name": ""
    },
    {
        "code": "lmo",
        "name": ""
    },
    {
        "code": "ln",
        "name": ""
    },
    {
        "code": "lo",
        "name": ""
    },
    {
        "code": "lt",
        "name": ""
    },
    {
        "code": "ltg",
        "name": ""
    },
    {
        "code": "luo",
        "name": ""
    },
    {
        "code": "lus",
        "name": ""
    },
    {
        "code": "lv",
        "name": ""
    },
    {
        "code": "mai",
        "name": ""
    },
    {
        "code": "mak",
        "name": ""
    },
    {
        "code": "mg",
        "name": ""
    },
    {
        "code": "mi",
        "name": ""
    },
    {
        "code": "min",
        "name": ""
    },
    {
        "code": "mk",
        "name": ""
    },
    {
        "code": "ml",
        "name": ""
    },
    {
        "code": "mn",
        "name": ""
    },
    {
        "code": "mni-Mtei",
        "name": ""
    },
    {
        "code": "mr",
        "name": ""
    },
    {
        "code": "ms",
        "name": ""
    },
    {
        "code": "ms-Arab",
        "name": ""
    },
    {
        "code": "mt",
        "name": ""
    },
    {
        "code": "my",
        "name": ""
    },
    {
        "code": "ne",
        "name": ""
    },
    {
        "code": "new",
        "name": ""
    },
    {
        "code": "nl",
        "name": ""
    },
    {
        "code": "no",
        "name": ""
    },
    {
        "code": "nr",
        "name": ""
    },
    {
        "code": "nso",
        "name": ""
    },
    {
        "code": "nus",
        "name": ""
    },
    {
        "code": "ny",
        "name": ""
    },
    {
        "code": "oc",
        "name": ""
    },
    {
        "code": "om",
        "name": ""
    },
    {
        "code": "or",
        "name": ""
    },
    {
        "code": "pa",
        "name": ""
    },
    {
        "code": "pa-Arab",
        "name": ""
    },
    {
        "code": "pag",
        "name": ""
    },
    {
        "code": "pam",
        "name": ""
    },
    {
        "code": "pap",
        "name": ""
    },
    {
        "code": "pl",
        "name": ""
    },
    {
        "code": "ps",
        "name": ""
    },
    {
        "code": "pt",
        "name": ""
    },
    {
        "code": "qu",
        "name": ""
    },
    {
        "code": "rn",
        "name": ""
    },
    {
        "code": "ro",
        "name": ""
    },
    {
        "code": "rom",
        "name": ""
    },
    {
        "code": "ru",
        "name": ""
    },
    {
        "code": "rw",
        "name": ""
    },
    {
        "code": "sa",
        "name": ""
    },
    {
        "code": "scn",
        "name": ""
    },
    {
        "code": "sd",
        "name": ""
    },
    {
        "code": "sg",
        "name": ""
    },
    {
        "code": "shn",
        "name": ""
    },
    {
        "code": "si",
        "name": ""
    },
    {
        "code": "sk",
        "name": ""
    },
    {
        "code": "sl",
        "name": ""
    },
    {
        "code": "sm",
        "name": ""
    },
    {
        "code": "sn",
        "name": ""
    },
    {
        "code": "so",
        "name": ""
    },
    {
        "code": "sq",
        "name": ""
    },
    {
        "code": "sr",
        "name": ""
    },
    {
        "code": "ss",
        "name": ""
    },
    {
        "code": "st",
        "name": ""
    },
    {
        "code": "su",
        "name": ""
    },
    {
        "code": "sv",
        "name": ""
    },
    {
        "code": "sw",
        "name": ""
    },
    {
        "code": "szl",
        "name": ""
    },
    {
        "code": "ta",
        "name": ""
    },
    {
        "code": "te",
        "name": ""
    },
    {
        "code": "tet",
        "name": ""
    },
    {
        "code": "tg",
        "name": ""
    },
    {
        "code": "th",
        "name": ""
    },
    {
        "code": "ti",
        "name": ""
    },
    {
        "code": "tk",
        "name": ""
    },
    {
        "code": "tl",
        "name": ""
    },
    {
        "code": "tn",
        "name": ""
    },
    {
        "code": "tr",
        "name": ""
    },
    {
        "code": "ts",
        "name": ""
    },
    {
        "code": "tt",
        "name": ""
    },
    {
        "code": "ug",
        "name": ""
    },
    {
        "code": "uk",
        "name": ""
    },
    {
        "code": "ur",
        "name": ""
    },
    {
        "code": "uz",
        "name": ""
    },
    {
        "code": "vi",
        "name": ""
    },
    {
        "code": "xh",
        "name": ""
    },
    {
        "code": "yi",
        "name": ""
    },
    {
        "code": "yo",
        "name": ""
    },
    {
        "code": "yua",
        "name": ""
    },
    {
        "code": "yue",
        "name": ""
    },
    {
        "code": "zh",
        "name": ""
    },
    {
        "code": "zh-CN",
        "name": ""
    },
    {
        "code": "zh-TW",
        "name": ""
    },
    {
        "code": "zu",
        "name": ""
    }
]